











import {
  projectAuth,
  signInWithPopup,
  GoogleAuthProvider,
} from '@/firebase/config'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  async googleLogin() {
    const googleAuthProvider = new GoogleAuthProvider()
    return signInWithPopup(projectAuth, googleAuthProvider)
      .then((result: any) => {
        this.$router.push({ name: 'home' })
        return result
      })
      .catch((e: any) => {
        this.$buefy.toast.open({
          message: e.message,
          type: 'is-danger',
        })
      })
  }
}
